import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";
import PageBanner from "../components/PageBanner";
import Seo from "../components/Seo";
import { useProducts } from "../lib/ProductsContext";
import { optimizeImg } from "../lib/img";

const MotionLink = motion(Link);

export default function CategoriesPage() {
  const { categories, products } = useProducts();

  return (
    <div className="min-h-screen bg-white text-[#222222]" data-testid="categories-page">
      <Seo
        title="Tüm Kategoriler"
        description="Doğum gününden yıldönümüne, her özel an için özenle hazırlanmış Frida Çiçekçilik koleksiyonlarının tamamı."
        path="/kategoriler"
      />
      <Header />

      <PageBanner
        eyebrow="Koleksiyonlar"
        title="Tüm Kategoriler"
        subtitle="Doğum gününden yıldönümüne, her özel an için özenle hazırlanmış koleksiyonlarımızın tamamı."
        breadcrumb={[{ label: "Kategoriler" }]}
      />

      <section className="py-16 md:py-20 bg-white">
        <div className="frida-container">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-7" data-testid="all-categories-grid">
            {categories.map((cat, i) => {
              const count = products.filter((p) => p.cat === cat.id).length;
              return (
                <MotionLink
                  key={cat.id}
                  to={`/kategori/${cat.id}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.5, delay: (i % 8) * 0.04, ease: "easeOut" }}
                  className="group relative aspect-[3/4] rounded-3xl overflow-hidden lift-card cursor-pointer block isolate"
                  data-testid={`all-categories-card-${cat.id}`}
                >
                  <div className="absolute inset-0 zoom-on-hover">
                    <img
                      src={optimizeImg(cat.image, 450)}
                      alt={cat.name}
                      width="450"
                      height="600"
                      className="w-full h-full object-cover"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/0" />

                  <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/95 backdrop-blur-md flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
                    <ArrowUpRight className="w-4 h-4 text-[#222222]" />
                  </div>

                  <div className="absolute inset-x-0 bottom-0 p-4 md:p-5 lg:p-6 flex flex-col justify-end min-h-[5.5rem]">
                    <div className="text-[10px] tracking-[0.25em] uppercase text-white/75 mb-1.5 font-medium">
                      {count} Ürün
                    </div>
                    <h3 className="font-serif text-base md:text-xl lg:text-2xl text-white leading-snug line-clamp-2 text-balance">
                      {cat.name}
                    </h3>
                  </div>
                </MotionLink>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
